// src/plugins/nprogress.ts
import router from '@/router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default () => {
  NProgress.configure({
    showSpinner: false,
    speed: 400,
    trickleSpeed: 200,
  })

  router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
  })

  router.afterEach(() => {
    NProgress.done()
  })
}
